import html from "../assets/icons/html-5.svg";
import css from "../assets/icons/css3.svg";
import mongodb from "../assets/icons/mongoDB.svg";
import javascript from "../assets/icons/javascript.svg";
import react from "../assets/icons/react.svg";
import typescript from "../assets/icons/typescript.svg";
import sql from "../assets/icons/sql.svg";
import node from "../assets/icons/nodejs.svg";
import vscode from "../assets/icons/vscode.png";
import express from "../assets/icons/express.svg";
import scss from "../assets/icons/scss.svg";
import mocha from "../assets/icons/mocha.svg";
import chai from "../assets/icons/chai.svg";
import bitbucket from "../assets/icons/bitbucket.svg";
import profile from "../assets/profile.webp";
import Riksof from "../assets/Riksof-logo.webp";
import nandos from "../assets/projects/nandos-mockup.png";
import pizzini from "../assets/projects/pizzini-mockup.png";
import notes from "../assets/projects/sticky-mockup.png";
import about from "../assets/about-image.png";
import download from "../assets/download.svg";
import secDownload from "../assets/downloadSecondary.svg";
import IU from "../assets/iqraUniversityLogo.webp";
import BSEK from "../assets/BSEKLogo.webp";
import BIEK from "../assets/BIEKLogo.webp";
import github from "../assets/social-icons/github.svg";
import linkedin from "../assets/social-icons/linkedin.svg";
import medium from "../assets/social-icons/medium.svg";
import stackoverflow from "../assets/social-icons/stackoverflow.svg";
import facebook from "../assets/social-icons/facebook.svg";
import youtube from "../assets/social-icons/youtube.svg";
import email from "../assets/email.svg";
import phone from "../assets/phone.svg";
import location from "../assets/location.svg";
import skype from "../assets/skype.svg";
import nandosFull from "../assets/projects/nandosfull.png";
import pizziniFull from "../assets/pizzini-full.png";
import stikcyNotesfull from "../assets/projects/stickynotesfull.png";
import githubFinder from "../assets/projects/github-profile-finder.png";
import dbCompImg from "../assets/achievements/db_competition.jpeg";
const portfolioData = [
  {
    nav: {
      downloadSvg: download,
      secondaryDownloadSvg: secDownload
    },
    profile: {
      id: 1,
      firstName: "Muhammad",
      lastName: "Taha",
      jobTitle: "Software Engineer",
      image: profile,
      date: {
        day: "07",
        month: "August"
      }
    },
    home: {
      name: "Muhammad Taha",
      jobTitle: "Software Developer",
      image: profile,
      description:
        "Software engineer with a knack for problem-solving and a keen eye for detail. Committed to delivering high-quality code and driving continuous improvement in software development practices."
    },
    socials: [
      {
        name: "Linkedin",
        href: "https://www.linkedin.com/in/mtahashahid/",
        icon: linkedin
      },
      {
        name: "Github",
        href: "https://www.github.com/mtahashahid",
        icon: github
      }
    ],
    about: {
      image: about,
      description:
        "I am a Software Engineer with a passion for problem-solving and a meticulous approach to coding. I am dedicated to delivering top-notch solutions and constantly refining my skills to stay at the forefront of software development."
    },
    skills: {
      skills: [
        {name: "HTML", icon: html},
        {name: "CSS", icon: css},
        {name: "SCSS", icon: scss},
        {name: "JavaScript", icon: javascript},
        {name: "TypeScript", icon: typescript},
        {name: "Nodejs", icon: node},
        {name: "MongoDB", icon: mongodb},
        {name: "Reactjs", icon: react},
        {name: "Expressjs", icon: express},
        {name: "Github", icon: github},
        {name: "VS Code", icon: vscode},
        {name: "SQL/MySQL", icon: sql},
        {name: "Mocha", icon: mocha},
        {name: "Chai", icon: chai},
        {name: "Butbucket", icon: bitbucket}
      ]
    },
    experiences: [
      {
        title: "Junior Software Engineer",
        company: "RIKSOF Private Limited",
        duration: "March 2024 - Present",
        description: [
          "Understanding client requirements and adding new features in previously developed applications.",
          "Writing comprehensive unit test cases to ensure robust development practices.",
          "Troubleshooting, debugging and performing bug fixes to maintain application reliability."
        ],
        logo: Riksof
      },
      {
        title: "Trainee Developer",
        company: "RIKSOF Private Limited",
        duration: "Nov 2023 - Mar 2024",
        description: [
          "Working under guidance of Senior Developers.",
          "Performing Bugfixes.",
          "Troubleshooting and debugging.",
          "Adding minor features in previously developed applications"
        ],
        logo: Riksof
      }
      // Add more experiences as needed
    ],
    educations: {
      eductaion: [
        {
          institute: "IQRA University",
          degree: "Bachelor of Science",
          fieldOfStudy: "Computer Science",
          duration: "Jan 2019 - June 2023",
          description: [
            "Developed and maintained web applications using React and Node.js.",
            "Collaborated with cross-functional teams to define, design, and ship new features.",
            "Implemented automated testing and CI/CD pipelines using Jenkins."
          ],
          universityImage: IU
        },
        {
          institute: "Board of Intermediate Education",
          degree: "Intermediate",
          fieldOfStudy: "Science - Pre Engineering",
          duration: "March 2018",
          description: [
            "Developed and maintained web applications using React and Node.js.",
            "Collaborated with cross-functional teams to define, design, and ship new features.",
            "Implemented automated testing and CI/CD pipelines using Jenkins."
          ],
          universityImage: BIEK
        },
        {
          institute: "Board of Secondary Education",
          degree: "Matriculation",
          fieldOfStudy: "Science",
          duration: "March 2015",
          description: [
            "Developed and maintained web applications using React and Node.js.",
            "Collaborated with cross-functional teams to define, design, and ship new features.",
            "Implemented automated testing and CI/CD pipelines using Jenkins."
          ],
          universityImage: BSEK
        }
      ]
    },
    projectsData: [
      {
        id: 1,
        name: "Nandos",
        img: nandos,
        displayImg: nandosFull,
        githubUrl: "https://github.com/mtahashahid/Nandos-Resturant",
        link: "https://nandos-site.netlify.app/",
        githubIcon: github,
        description:
          "Crafted using React, this sleek and modern single-page website offers an immersive dining experience. It showcases the restaurant's menu, ambiance, and special offerings through a seamless and intuitive design. With responsive layouts and interactive elements, it provides an engaging and user-friendly interface for visitors to explore the restaurant's offerings."
      },
      {
        id: 2,
        name: "Pizzini",
        img: pizzini,
        displayImg: pizziniFull,
        githubUrl: "https://www.github.com/mtahashahid",
        link: "https://pizzini-site.netlify.app/",
        githubIcon: github,
        description:
          "Developed this responsive frontend using React and custom CSS. The project showcases a modern user interface with a visually appealing design."
      },
      {
        id: 3,
        name: "Github Profile Finder",
        img: githubFinder,
        displayImg: githubFinder,
        githubUrl: "https://github.com/mtahashahid/github-profile-finder",
        link: "https://dev-github-profile-finder.vercel.app/",
        githubIcon: github,
        description:
          "Developed with Next.js and Tailwind CSS, allows users to search for and view GitHub profiles, showcasing essential information like repositories and followers. The app provides a clean, responsive interface for quick access to developer details."
      },
      {
        id: 4,
        name: "Sticky Notes",
        img: notes,
        displayImg: stikcyNotesfull,
        githubUrl: "https://www.github.com/mtahashahid",
        link: "https://stickynotesforyou.netlify.app/",
        githubIcon: github,
        description:
          "Developed a sticky notes app using TypeScript and React, allowing users to create, edit, and organize notes. The app features a dynamic and responsive design, ensuring a smooth user experience across devices."
      }
    ],
    socialLinks: [
      {
        url: "https://www.linkedin.com/in/mtahashahid/",
        icon: linkedin,
        name:"linkedin"
      },
      {
        url: "https://www.github.com/mtahashahid",
        icon: github,
        name: "github"
      },
      {
        url: "https://www.medium.com",
        icon: medium,
        name:"medium"
      },
      {
        url: "https://www.stackoverflow.com",
        icon: stackoverflow,
        name:"stackoverflow"
      },
      {
        url: "https://www.facebook.com",
        icon: facebook,
        name:"facebook"
      },
      {
        url: "https://www.youtube.com",
        icon: youtube,
        name:"youtube"
      }
    ],
    contactInfo: [
      {
        email: "taha_shahid@outlook.com",
        emailIcon: email
      },
      {
        phone: "03xxxxxxxxx",
        phoneIcon: phone
      },
      {
        location: "Karachi, Pakistan",
        locationIcon: location
      },
      {
        skype: "-",
        skypeIcon: skype
      }
    ],
    serviceData: [
      {
        name: "Web Development",
        img: "img/service/1.jpg",
        description: "I design stunning website."
      },
      {
        name: "Wordpress Development",
        img: "img/service/2.jpg",
        description: "I design stunning wordpress website."
      }
    ],
    achievement: [
      {
        achievementName: "Database Design",
        achievementDescription:
          "Participated and achieved 1st position in database design category in an internal tech competition organised by FEST(Faculty of Engineering Science and Technology at IQRA university)",
        venue: "IQRA University",
        competitionName: "IU Techies'22",
        image: dbCompImg,
        date: ""
      }
    ]
  }
];

export default portfolioData;
